<template>
  <div class="w-100">
    <div v-if="tib === null">
      <login
        :tibPath="'/timetracking'"
        :tibName="'' + getYearFromTimestamp(new Date())"
        @tib="setTib"
        @setloggedin="console.info('setLoggedIn')"
        @cancel="console.info('cancel')"
        @error="error"
        :tp="tp"
        :showDomainAccountList="false"
        :description="'Nur Benutzer, welche für die Zeiterfassung aktiviert wurden, können sich anmelden!'"
      ></login>
    </div>

    <div v-if="tib" class="row mt-3">
      <div class="col w-100 my-3">
        <h1>Zeiterfassung</h1>
        <button
          type="button"
          class="btn btn-danger w-100"
          @click="loginAndStop()"
          :disabled="intervalUpdateTime == null"
        >
          <i class="fas fa-stop"></i>&nbsp;STOP {{ timeString }}
        </button>
        <div class="mt-3">
          <h3 class="my-3">
            {{
              servicekleber &&
              servicekleber.tib &&
              (servicekleber.tib.name == servicekleber.data.extRef
                ? servicekleber.tib.name
                : servicekleber.tib.name + " " + servicekleber.data.extRef)
            }}
          </h3>
          <div v-for="(taskChecked, index) in tasksChecked" :key="index">
            <input
              type="checkbox"
              :id="'task' + index"
              v-model="taskChecked.on"
            />
            <label :for="'task' + index">{{ taskChecked.task.de }}</label>
          </div>
        </div>
        <button
          v-if="!showSaving"
          type="button"
          class="mt-3 btn btn-primary w-100"
          @click="loginAndStart()"
        >
          <i class="fas fa-play"></i>&nbsp;Stempeln
        </button>
        <button
          v-if="showSaving"
          type="button"
          class="mt-3 btn btn-primary w-100 disabled"
        >
          speichern....
        </button>
        <div class="mt-3" v-if="lastTrackingItem">
          {{ timeOfLastStamp }} {{ lastTrackingItem.name }}
          {{ lastTrackingItem.stopped ? "STOP" : lastTrackingItem.tasks }}
        </div>
        <div class="mt-3">
          <button
            type="button"
            class="btn btn-outline-dark w-100"
            @click="showDetails = !showDetails"
          >
            Stempelungen {{ showDetails ? "schliessen" : "" }}
          </button>
          <timeTrackingDetails
            v-if="showDetails"
            :json="tib.data"
            :allowEdit="false"
          ></timeTrackingDetails>
        </div>

        <div class="mt-3">
          <button
            type="button"
            class="btn btn-outline-dark w-100"
            @click="showProperties = !showProperties"
          >
            Eigenschaften {{ showProperties ? "schliessen" : "" }}
          </button>
          <servicekleberProperties
            v-if="showProperties"
            :servicekleber="servicekleber"
            :propertiesForeignKey="settings.propertiesForeignKey"
            :properties="properties"
          ></servicekleberProperties>
        </div>
      </div>
    </div>
    <div
      v-if="tib == null"
      class="mt-3 alert alert-warning alert-dismissible fade show"
    >
      <p>Zeiterfassung nicht möglich!</p>
    </div>
  </div>
</template>

<script>
import {
  formatSecondsAsWorkTime,
  getTimeFromSeconds,
  getYearFromTimestamp,
  getTrackingSecondsToday,
  addTrackingStampToTib,
  evalTasksFromSettings,
  getLastActiveTasksFromServicekleber,
  getLastWorkingDay,
  newYearTracking
} from "@/common/timetrackingutils";

import { TT_URL } from "@/common/constants";
import axios from "axios";

import login from "@/components/Login.vue";
import servicekleberProperties from "@/components/timetracking/ServicekleberProperties.vue";
import timeTrackingDetails from "@/components/timetracking/TimeTrackingDetails.vue";

export default {
  name: "timetracking",
  components: {
    login,
    servicekleberProperties,
    timeTrackingDetails
  },
  data: function() {
    return {
      tasksChecked: [],
      intervalUpdateTime: null,
      timeString: "",
      lastWorkingDay: null,
      lastTrackingItem: null,
      tib: null,
      username: "",
      password: "",
      showDetails: false,
      showProperties: false,
      showSaving: false,
      getYearFromTimestamp: getYearFromTimestamp
    };
  },
  mounted() {
    this.getTrackingTibForCurrentUser(null);
  },
  methods: {
    initTrackingFromTib() {
      this.tasksChecked = [];
      if (this.tib) {
        let needSave = false;
        if (
          this.tib.name.trim() !== getYearFromTimestamp(new Date()).toString()
        ) {
          this.tib = null;
          return;
        }
        if (this.tib.data === "") {
          this.tib.data = JSON.stringify(newYearTracking());
          needSave = true;
        }
        // init the tasks from the last time tracking
        this.lastWorkingDay = getLastWorkingDay(JSON.parse(this.tib.data));
        let activeTasks = getLastActiveTasksFromServicekleber(
          this.lastWorkingDay,
          this.servicekleber.tib.id
        );

        let taskIds = evalTasksFromSettings(
          this.servicekleber.tib.flagsList,
          this.settings
        );
        for (const task of this.settings.tasks) {
          if (taskIds.indexOf(task.id) >= 0) {
            this.tasksChecked.push({
              task: task,
              on: activeTasks.indexOf(task.id) >= 0
            });
          }
        }
        if (
          this.settings.tasksPerExtRef != null &&
          this.settings.tasksPerExtRef[this.servicekleber.data.extRef] != null
        ) {
          for (const task of this.settings.tasksPerExtRef[
            this.servicekleber.data.extRef
          ]) {
            this.tasksChecked.push({
              task: task,
              on: activeTasks.indexOf(task.id) >= 0
            });
          }
        }
        this.updateTime();
        if (needSave) {
          this.updateTib();
        }
      }
    },
    loginAndStart() {
      this.getTrackingTibForCurrentUser(this.start);
      this.showDetails = false;
    },
    loginAndStop() {
      this.getTrackingTibForCurrentUser(this.stop);
      this.showDetails = false;
    },
    start(timeInSeconds) {
      console.info("start");
      this.lastTrackingItem = addTrackingStampToTib(
        timeInSeconds,
        this.tib,
        false,
        this.servicekleber,
        this.getActiveTasks()
      );
      if (this.intervalUpdateTime == null) {
        this.intervalUpdateTime = setInterval(() => this.updateTime(), 500);
      }
      this.updateTib();
      this.showSaving = true;
      console.info(JSON.stringify(this.tib.data));
    },
    stop(timeInSeconds) {
      console.info("stop");
      this.lastTrackingItem = addTrackingStampToTib(
        timeInSeconds,
        this.tib,
        true,
        this.servicekleber,
        this.getActiveTasks()
      );
      clearInterval(this.intervalUpdateTime);
      this.intervalUpdateTime = null;
      this.updateTib();
      console.info(JSON.stringify(this.tib.data));
    },
    getActiveTasks() {
      let activeTasks = [];
      for (let taskChecked of this.tasksChecked) {
        if (taskChecked.on) {
          activeTasks.push(taskChecked.task.id);
        }
      }
      return activeTasks;
    },
    updateTime() {
      let seconds = getTrackingSecondsToday(this.tib);
      this.timeString = formatSecondsAsWorkTime(seconds);
    },
    updateTib() {
      console.info("update tib");
      let self = this;
      axios
        .post(TT_URL + "/api/rest/tibtix/updateTib", this.tib)
        .then(response => {
          console.info("saved" + response);
          self.showSaving = false;
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
          self.showSaving = false;
        });
      console.info("tibupdated");
      this.$emit("tibupdated");
    },
    getTrackingTibForCurrentUser(functionToCall) {
      let self = this;
      axios
        .get(TT_URL + "/view/getTibModelByTibSessionCookie")
        .then(response => {
          console.info("access tib by cookie");
          if (response.data) {
            self.tib = response.data;
            if (functionToCall !== null) {
              let servertime = Number.parseInt(response.headers.servertime, 10);
              functionToCall.call(self, servertime);
            } else {
              self.initTrackingFromTib();
            }
          } else {
            self.tib = null;
            self.initTrackingFromTib();
          }
          if (
            self.lastWorkingDay != null &&
            self.lastWorkingDay.trackingItems.length > 0 &&
            !self.lastWorkingDay.trackingItems[
              self.lastWorkingDay.trackingItems.length - 1
            ].stopped &&
            self.intervalUpdateTime == null
          ) {
            self.intervalUpdateTime = setInterval(() => self.updateTime(), 500);
          }
        })
        .catch(function(error) {
          console.info("error" + error);
          self.tib = null;
        });
    },
    setTib(tibFromLogin) {
      if (tibFromLogin.name == getYearFromTimestamp(new Date())) {
        this.tib = tibFromLogin;
        this.initTrackingFromTib();
      }
    },
    error(msg) {
      this.$emit("error", msg);
    }
  },
  props: {
    tp: Object,
    servicekleber: Object,
    settings: Object,
    properties: Array
  },
  // watch: {
  //   lastWorkingDay: {
  //     deep: true
  //   }
  // },
  computed: {
    timeOfLastStamp: function() {
      if (this.lastTrackingItem) {
        return getTimeFromSeconds(this.lastTrackingItem.timestamp);
      } else {
        return "--:--:--";
      }
    },
    lastWorkingDayTrackingItems: function() {
      return this.lastWorkingDay == null
        ? []
        : this.lastWorkingDay.trackingItems;
    }
  }
};
</script>
